import styled, { css } from 'styled-components';
import { Chip } from '@mui/material';

import colors from '../../../../../styles/colors';

const TaskContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 20px 16px;
`;

const TaskTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.base.secondary2};
`;

const TaskTitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 6px;
  column-gap: 12px;
`;

const PriorityChip = styled(Chip)`
  height: 22px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
`;

const TaskMeta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: ${colors.shades.gamma10};

  svg {
    font-size: 16px;
  }

  ${({ $isOverdue }) => $isOverdue
    && css`
      color: ${colors.base.danger};
      font-weight: 700;
    `}
`;

const TaskInstructions = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${colors.shades.gamma10};
  white-space: pre-wrap;
`;

const SourcePreviewCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  background: ${colors.base.gamma};
  border-left: 3px solid ${colors.shades.secondary4};
`;

const SourcePreviewLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${colors.shades.gamma10};
`;

const SourcePreviewText = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${colors.base.secondary2};
  white-space: pre-wrap;
`;

export {
  TaskContainer,
  TaskTitle,
  TaskTitleRow,
  PriorityChip,
  TaskMeta,
  TaskInstructions,
  SourcePreviewCard,
  SourcePreviewLabel,
  SourcePreviewText,
};
